import sctBnbCakeLpFarmingPool65 from "../abis/development/sctBnb/pools/65";

const host = "https://bscscan.com/address";
const swapHost = "https://pancakeswap.finance/add";
const pairHost = "https://pancakeswap.info/pool";

export default [
  {
    title: "SCT-BNB Cake LP Farming",
    temperature: 65,
    type: "bnb",
    contractAddress: "0xde75c4e1d37dadcb3170bd4e79bb76162d8a2641",
    minApr: 159,
    abi: sctBnbCakeLpFarmingPool65.abi,
    url: `${host}/0xde75c4e1d37dadcb3170bd4e79bb76162d8a2641`,
    swapUrl: `${swapHost}/BNB/0xa747f2aefacdf9b1e19d94ab3a0343a490c684a3`,
    pairUrl: `${pairHost}/0x3ef02ce377889b18695dd5d466dbf7d9baf2e632`,
  },
];
